import React from 'react';
import { Box, Grid } from '@mui/material';
import { ReactComponent as LaptopIconAssess } from 'assets/laptopAssess.svg';
import TypographyWithI18N from './TypographyWithI18N';

const UnsupportedDevicePage = () => {
  const baseID = 'unsupported-device-page';

  return (
    <Grid
      item
      container
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      sx={{ mb: 8, px: '0.25rem' }}
      data-testid={`${baseID}-wrapper`}
    >
      <Box sx={{ mt: '10rem' }}>
        <LaptopIconAssess />
      </Box>
      <TypographyWithI18N
        i18nKey={'unsupportedDevicePageTitle'}
        className='kfic2-smallHeaderBold'
        sx={{
          mt: 3,
          mb: 2,
          fontWeight: '700 !important',
          textAlign: 'center',
        }}
        tabIndex={0}
      />
      <TypographyWithI18N
        i18nKey={'unsupportedDevicePageDescription'}
        className='kfic2-bodyText'
        sx={{
          maxWidth: '30rem',
          textAlign: 'center',
          mb: '4rem',
        }}
        tabIndex={0}
      />
    </Grid>
  );
};

export default UnsupportedDevicePage;
